const env = {
    isProduction : process.env.NODE_ENV === 'production'
    && window.location.hostname.indexOf('marketplace-dev') < 0
    && window.location.hostname.indexOf('marketplace-qa') < 0
}

export default env;
